/**
 * A custom element wrapper to add global onHistoryChange dispatcher
 * @typedef {Object} HistoryElement
 */
export default class HistoryElement extends HTMLElement {

	constructor() {

		super();

		window.Zero.events.history = window.Zero.events.history || [];


		if(this.onHistoryChange) {

			window.Zero.events.history.push(this);

			this.addEventListener("history", this.onHistoryChange.bind(this));
		}
	}
}
